export default __webpack_public_path__ + "static/media/select.aa2507b4.svg";